import React, { useEffect, useRef, useState } from 'react';
import { FORM_NAME, TIMER_EXPIRY_TIME, RECORDER, RECORDER_STATE, RECORDER_STATES, TIMER_EXPIRY } from './fields';
import { useSelector, useDispatch } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import { faDotCircle, faPauseCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RecorderTimer = (props) => {
  const {
    [RECORDER_STATE]: recorderState,
    [TIMER_EXPIRY_TIME]: expiryTimestamp,
    [RECORDER]: recorder,
  } = useSelector(getFormValues(FORM_NAME));

  const [seconds, setSeconds] = useState(getSecondsFromTimestamp(expiryTimestamp));
  const intervalRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    function clearIntervalRef() {
      if (!intervalRef.current) {
        return;
      }

      dispatch(change(FORM_NAME, TIMER_EXPIRY_TIME, null));
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    function handleExpire() {
      clearIntervalRef();
      recorder.stop();
    }

    function start() {
      if (intervalRef.current) {
        clearIntervalRef();
      }

      intervalRef.current = setInterval(() => {
        const seconds = getSecondsFromTimestamp(expiryTimestamp);

        if (seconds >= TIMER_EXPIRY) {
          handleExpire();
        }

        setSeconds(seconds);
      }, 1000);
    }

    function pause() {
      clearIntervalRef();
    }

    function resume() {
      if (intervalRef.current) {
        return;
      }

      intervalRef.current = setInterval(() => {
        setSeconds((prevSeconds) => {
          const seconds = prevSeconds + 1;
          if (seconds >= TIMER_EXPIRY) {
            handleExpire();
          }

          return seconds;
        });
      }, 1000);
    }

    if (recorderState) {
      switch (recorderState) {
        case RECORDER_STATES.RECORDING:
          start();
          break;
        case RECORDER_STATES.PAUSED:
          pause();
          break;
        case RECORDER_STATES.RESUME:
          resume();
          break;
        default:
      }
    }
    return clearIntervalRef;
  }, [recorderState, expiryTimestamp, recorder, dispatch]);

  return (
    <div className={`ct-timer ${!recorderState ? 'ct-timer--hidden' : ''}`} data-e2e="ct-recorder-timer" {...props}>
      {recorderState === RECORDER_STATES.PAUSED || recorderState === RECORDER_STATES.WILL_RESUME ? (
        <FontAwesomeIcon className="ct-timer__icon ct-timer__default-icon" icon={faPauseCircle} size="xs" />
      ) : (
        <FontAwesomeIcon className="ct-timer__icon ct-timer__warn-icon" icon={faDotCircle} size="xs" />
      )}
      <span className="ct-timer__text">
        {formatTime(seconds)} / {formatTime(TIMER_EXPIRY)}
      </span>
    </div>
  );
};

const formatTime = (num) => {
  const mins = ('' + Math.floor(num / 60)).padStart(2, 0);
  const secs = ('' + Math.floor(num % 60)).padStart(2, 0);
  return `${mins}:${secs}`;
};

const getSecondsFromTimestamp = (expiry) => {
  const now = new Date().getTime();
  const milliSecondsDistance = expiry - now;

  const seconds = milliSecondsDistance > 0 ? Math.floor(milliSecondsDistance / 1000) : TIMER_EXPIRY;

  return TIMER_EXPIRY - seconds;
};
